function loadInAnimation() {
  // Used to hide animation on refresh
  // if (localStorage.getItem('materials-archive-animation-played') == 'true') return;
  // localStorage.setItem('materials-archive-animation-played', 'true');

  document.body.classList.add('load-materials-archive');
}
if (!Shopify.designMode) {
  loadInAnimation();
} else {
  document.body.classList.add('load-materials-archive');
  document.body.classList.add('materials-archive-animation-played');
}

function setupMouseTooltip(elem) {
  if (typeof Popper == 'object') {
    function generateGetBoundingClientRect(x = 0, y = 0) {
      return () => ({
        width: 0,
        height: 0,
        top: y - 12,
        right: x,
        bottom: y,
        left: x + 48,
      });
    }
    
    const virtualElement = {
      getBoundingClientRect: generateGetBoundingClientRect(),
    };
    
    const popper = elem.querySelector('.materials-gallery__item-label');
    const instance = Popper.createPopper(virtualElement, popper, {
      placement: 'right-start',
      modifiers: [
        {
          name: 'flip',
          enabled: false
        }
      ]
    });
    
    elem.addEventListener('mousemove', ({ clientX: x, clientY: y }) => {
      window.mouseX = x;
      window.mouseY = y;
      virtualElement.getBoundingClientRect = generateGetBoundingClientRect(x, y);
      instance.update();
    });
    window.addEventListener('scrollend', (event) => {
      virtualElement.getBoundingClientRect = generateGetBoundingClientRect(window.mouseX, window.mouseY);
      instance.update();
    })
  } else {
    setTimeout(function() { setupMouseTooltip(elem); }, 100);
  }
}

const items = document.querySelectorAll('.materials-gallery__item')

Array.from(items).forEach(item => {
  setupMouseTooltip(item);
})

// document.addEventListener('scroll', function(){
//   const is_mobile = window.matchMedia('(max-width: 768px)').matches;
//   let { scrollY } = window;
//   let offset = scrollY * .1;
//   for (let i=0; i < items.length; i++) {
//     if (is_mobile) {
//       if (i % 2 == 0) {
//         items[i].style.transform = `translateY(${offset}px)`;
//       } else {
//         items[i].style.transform = '';
//       }
//     } else {
//       if ((i+2) % 3 == 0) {
//         items[i].style.transform = `translateY(${offset}px)`;
//       } else {
//         items[i].style.transform = '';
//       }
//     }
//   }
//   document.querySelector('.materials-gallery__grid').style.paddingBottom = `${offset}px`;
// });



class MaterialsGalleryFilter extends HTMLElement {

  constructor() {
    super();
    this.collections = this.dataset.collections;
    this.galleryItems = document.querySelectorAll('.materials-gallery__item');
    this.initialGalleryItems = Array.from(this.galleryItems);
    this.galleryGrid = document.querySelector('.materials-gallery__grid');
    this.contentWrapper = document.querySelector('.materials-gallery__content-wrapper');
    this.is_mobile = window.matchMedia('(max-width: 768px)').matches;

    this.addEventListener('click', this.updateFilter.bind(this));

    // Seed the grid's active-filter attribute from the initially active tab
    // (server-rendered "All") so CSS scoping is correct before any click.
    if (this.dataset.active === 'true') {
      this.setActiveFilterAttr(this);
    }

    window.addEventListener('resize', () => {
      this.contentWrapper.style.height = `auto`;
    });
  }

  updateFilter(event) {
    const filter = event.target.closest('materials-gallery-filter');
    if (filter) {
      const filterValue = JSON.parse(filter.dataset.collections);
      
      this.contentWrapper.classList.add('is-updating');
      this.contentWrapper.style.height = `${this.contentWrapper.offsetHeight}px`;

      function updateContent() {
        this.galleryGrid.innerHTML = '';

        // Flip the grid's active-filter attribute now — after the previous tab's
        // items have been cleared, in the same frame the new items are appended.
        // Setting it on click instead would re-flow the still-visible old items
        // mid-transition (a visual break), so it must happen here.
        this.setActiveFilterAttr(filter);

        this.initialGalleryItems.forEach(item => {
          const itemCollection = parseInt(item.dataset.collection);
          if (filterValue.includes(itemCollection) || filterValue.length === 0) {
            this.galleryGrid.appendChild(item);
          }
        });

        this.contentWrapper.style.height = `${this.contentWrapper.querySelector('.materials-gallery__grid').offsetHeight}px`;
        document.querySelector('.materials-gallery__content-wrapper').classList.remove('is-updating');
      }
      this.updateActiveFilter(filter);
      setTimeout(updateContent.bind(this), 800)
      
      const analyticsData = {
        collection_title: 'Materials Archive',
        filter_type: 'Material Grouping',
        filter_value: filter.innerText
      };
      Shopify.analytics.publish('material_list_filtered', analyticsData)
    }
  }

  updateActiveFilter(filter) {
    const activeFilter = document.querySelector('materials-gallery-filter[data-active="true"]');
    if (activeFilter) {
      activeFilter.dataset.active = 'false';
    }
    filter.dataset.active = 'true';
    // Note: the grid's data-active-filter is set later, inside updateContent(),
    // once the old items are cleared — see updateFilter().
  }

  // Expose the active filter's label on the grid (handleized) so CSS can scope
  // tab-specific layout tweaks, e.g. [data-active-filter="velvet"].
  setActiveFilterAttr(filter) {
    const label = (filter.textContent || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    if (this.galleryGrid) {
      this.galleryGrid.dataset.activeFilter = label;
    }
  }
}

customElements.define('materials-gallery-filter', MaterialsGalleryFilter);